export default __webpack_public_path__ + "static/media/f3.5b12ce1d.jpg";